import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { SubSink } from "subsink";
import { DialogConfig, DialogService, InputDialogConfig, BdpDialogTypes } from '../../service/dialog/dialog.service';

@Component({
  selector: 'bdp-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss'],
  standalone :false
})
export class CommonDialogComponent implements OnInit, OnDestroy {
  dialogData: any = {};
  toasterData: any = {};
  private subscription = new SubSink();
  dialog: any = {
    confirm: <DialogConfig>{
      type: BdpDialogTypes.CONFIRM,
      visibility: false,
      width: '420px',
      header: '',
      body: '',
      action: 'Save',
      reject: 'Cancel',
      onAccept: () => { },
      onReject: () => { },
    },
    input: <InputDialogConfig>{
      type: BdpDialogTypes.INPUT,
      visibility: false,
      width: '420px',
      header: '',
      body: '',
      message: '',
      action: 'Yes',
      placeholder: '',
      onAccept: () => { },
      onReject: () => { },
    },
    signOut: <InputDialogConfig>{
      type: BdpDialogTypes.INPUT,
      visibility: false,
      width: '420px',
      header: '',
      body: '',
      message: '',
      action: 'Yes',
      placeholder: '',
      onAccept: () => { },
      onReject: () => { },
    }
  }

  sessionDialog: InputDialogConfig = {
    type: BdpDialogTypes.SESSION,
    visibility: false,
    width: '420px',
    header: '',
    body: '',
    message: '',
    action: 'Yes',
    placeholder: '',
    onAccept: () => { },
    onReject: () => { },
  }

  constructor(
    private dialogService: DialogService,
    private messageService: MessageService) {
    this.subscription.add(dialogService.$sharedDialog.subscribe((config: DialogConfig) => {
      if (config) {
        if (config.type == BdpDialogTypes.SESSION) {
          this.sessionDialog = { ...this.sessionDialog, ...config };
          setTimeout(() => {
            this.sessionDialog.visibility = false;
          }, environment.sessionDialogInterval)
        } else {
          this.dialog[config.type] = { ...this.dialog[config.type], ...config };
        }
      }
    }))
  }

  ngOnInit(): void {
    this.dialogData = this.dialogService.getConfirmData(false);
    this.toasterData = this.dialogService.getToasterData(false);
    this.subscription.add(
      this.dialogService.$dialogData.subscribe((dialogData: any) => {
        if (dialogData) {
          this.dialogData = dialogData;
        }
      }),
      this.dialogService.$toasterData.subscribe((toasterData: any) => {
        if (toasterData) {
          this.toasterData = toasterData;
          if (this.toasterData.hasUndo) {
            this.messageService.add({
              key: 'bdpToasterUndo',
              severity: toasterData.severity,
              detail: toasterData.content,
              life: 5000
            });
          } else {
            this.messageService.add({
              key: 'bdpToaster',
              severity: toasterData.severity,
              detail: toasterData.content,
              life: 5000
            });
          }
        }
      })
    )
  }


  accept() {
    if (this.dialogData.buttons.accept && this.dialogData.buttons.accept.action) {
      this.dialogData.buttons.accept.action();
    }
    this.dialogData.isOpen = false;
  }

  reject() {
    if (this.dialogData.buttons.reject && this.dialogData.buttons.reject.action) {
      this.dialogData.buttons.reject.action();
    }
    this.dialogData.isOpen = false;
  }

  undo() {
    if (this.toasterData.undo && this.toasterData.undo.action) {
      this.toasterData.undo.action();
    }
    this.messageService.clear();
  }

  closePopup() {
    if (this.toasterData.close) {
      this.toasterData.close();
    }
    this.messageService.clear();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
